import {Widget} from "base/assets/js/widget/Widget.js";
import {Layers} from "base/assets/js/widget/Layers.js";
import {CWays} from "base/assets/js/widget/CWays.js";
import {CommForm} from "base/assets/js/widget/CommForm.js";
import {Comm} from "base/assets/js/widget/Comm.js";
import {Comms} from "base/assets/js/widget/Comms.js";

export class CommControl extends Widget {

	_oComm;
	_eBaseParent;
	bMobile = false;

	run() {

		this._eBaseParent = this.bl().parentElement;

		this._on( 'Reply', 'click', () => {
			// для гостя просто Popup выведем
			if( this._getComms().bGuest ) {
				const oLayers = this._rel().typeOf( Layers ).find();
				oLayers.message( 'Войдите на сайт или зарегистрируйтесь, чтобы ответить' );
				return;
			}

			const oComm = this.getComm();

			// добавим направляющих, если надо
			const oCWays = this._rel().parent().typeOf( CWays ).find();
			oCWays.setMaxLevel( oComm.getLev() + 1 );
			oCWays.refresh( [ oComm ], oComm.getLev() + 1 );

			const oCommForm = this._rel().typeOf( CommForm ).find();

			// если это повторный клик по одной и той же кнопке "ответить"
			// просто сбрасываем форму
			if( oCommForm.getReplyTo() === oComm.getId() ) {
				oCommForm.reset();
				return;
			}
			oCommForm.setReplyTo( oComm.getId() );
			oCommForm.setLev( oComm.getLev() + 1 );
			oComm.bl().insertAdjacentElement( 'afterend', oCommForm.bl() );
			oCommForm.focus();
		} );

		this._on( 'Plus?', 'click', ( oEvent ) => {
			this._vote( 1 );
		} );

		this._on( 'Minus?', 'click', ( oEvent ) => {
			this._vote( 0 );
		} );

		this._on( 'ToParent?', 'click', ( oEvent ) => {
			this.getComm().scrollToParent();
		} );

		this._on( 'ToChild?', 'click', ( oEvent ) => {
			const sToMp = this.getComm().getFromChildMp();
			if( sToMp ) {
				this._getComms().showComment( sToMp );
			}
		} );
	}

	reset() {
		// если уехала форма, вернем на место
		if( this.bl().parentElement !== this._eBaseParent ) {
			this._eBaseParent.appendChild( this.bl() );
		}
		this._oComm = null;
	}

	setComm( oComm ) {
		this._oComm = oComm;

		// если есть куда выводить, выведем рейтинг
		if( this._el( 'Rate?' ) ) {
			this._el( 'Rate?' ).textContent = oComm.getRate();
		}
	}

	/**
	 * @return {Comm}
	 */
	getComm() {
		if ( typeof this._oComm === 'undefined' && !this.bMobile ) {
			this._oComm = this._rel().self().typeOf( Comm ).find();
		}
		return this._oComm;
	}

	_vote( iVoteType ) {
		const oComm = this.getComm();
		const oFormData = new FormData();
		oFormData.append( 'id', oComm.getId() );
		oFormData.append( 'type', 'comment' );
		oFormData.append( 'votetype', iVoteType );
		this.post( '/ajax/vote', oFormData )
			.then(
				( { rate } ) => {
					this._el( 'Rate' ).textContent = rate;
					oComm.setRate( rate );
					oComm.setVoteDeny();
				},
				::this.ajaxPopupCatch
			);

	}

	_getComms() {
		if( !this._oComms ) {
			this._oComms = this._rel().parent().typeOf(Comms).find();
		}
		return this._oComms;
	}
}
